import React, { useState } from 'react';
import './styles/index.css';

import Header from './Component/header';
import Slider1 from './Component/slider1';
import Brands from './pages/brands.jsx';
import AboutUs from './pages/aboutUs';
import ContactUs from './pages/contactUs';
import OurClients from './pages/ourClients.jsx';
import Footer from './Component/footer.jsx';
import LocateUs from './Component/locateUs.jsx';

function App() {

  return (
    <>
      <Header />
      <Slider1/>
      <Brands/>
      <AboutUs/>
      <OurClients/>
      <ContactUs/>
      <LocateUs/>
      <Footer/>
      
    </>
  );
}

export default App;
